export default {
    getHeaderFieldsEprofileAktProblemak: state => state.headerFieldsEprofileAktProblemak,
    getFormActionsEprofileAktProblemak: state => state.formActionsEprofileAktProblemak,
    getActionsEprofileAktProblemak: state => state.actionsEprofileAktProblemak,
    getRowActionsEprofileAktProblemak: state => state.rowActionsEprofileAktProblemak,
    getSearchFields: state => state.searchFields,
    isFormOpenEprofileAktProblemak: state => state.formIsOpen,
    isGridOpenEprofileAktProblemak: state => state.gridIsOpen
}
